import { Background, Displaying } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Slide from "@mui/material/Slide";
import { useEffect } from "react";
import { ZERO_DIGIT } from "../../../../constants/env";
import useIsMobile from "../../../../hooks/device/useIsMobile";
import { useSearchModule } from "../../../hooks/useSearchModule";
import { DefaultLayoutContentContainer } from "../../../../components/layouts/default-layout/components/DefaultLayoutContentContainer";
import { Results } from "./Results";

const SearchLayoutContentContainer = styled(DefaultLayoutContentContainer)(() => ({
  display: Displaying.flex,
  zIndex: 3,
  backgroundColor: Background.default,
}));

function SearchDesktop(): JSX.Element {
  const isMobile = useIsMobile();
  const { isVisible, results, searchText, loading } = useSearchModule();

  useEffect(() => {
    window.scrollTo({ top: ZERO_DIGIT, left: ZERO_DIGIT });
  }, [results]);

  return (
    <Slide direction="left" mountOnEnter unmountOnExit in={isVisible}>
      <SearchLayoutContentContainer isMobile={isMobile}>
        <Results results={results} loading={loading} searchText={searchText} />
      </SearchLayoutContentContainer>
    </Slide>
  );
}

export default SearchDesktop;
